export default "__VITE_ASSET__BuYUos7P__"